import { getAuth } from 'firebase/auth';
import { app } from './firebase';

const ADMIN_BUSINESS_URL =
  'https://us-central1-roamr-4f8ad.cloudfunctions.net/adminBusinessVerification';

// The function itself re-checks the caller's ID token email server-side —
// this client is just a thin wrapper, not the actual gate.
async function callAdmin(url, body) {
  if (!app) throw new Error('Firebase not configured.');
  const auth = getAuth(app);
  const user = auth.currentUser;
  if (!user) throw new Error('Must be signed in.');

  const idToken = await user.getIdToken();
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `Server error ${res.status}`);
  return data;
}

export async function listPendingBusinessRequests() {
  const data = await callAdmin(ADMIN_BUSINESS_URL, { action: 'list' });
  return data.requests || [];
}

export async function reviewBusinessRequest(uid, approve) {
  return callAdmin(ADMIN_BUSINESS_URL, { action: approve ? 'approve' : 'reject', uid });
}

export async function listVerifiedBusinesses() {
  const data = await callAdmin(ADMIN_BUSINESS_URL, { action: 'list_verified' });
  return data.requests || [];
}

export async function revokeBusinessVerification(uid) {
  return callAdmin(ADMIN_BUSINESS_URL, { action: 'revoke', uid });
}
